import React from "react";
import Seo from "../seo/Seo";
import Breadcrumbs from "./Breadcrumbs";

const Pagenotfound = () => {
  return (
    <div className="container thank">
      <Seo
        title="Page not found | Connct"
        description="This page is not on the Connct website."
        path="/404"
        noindex
        breadcrumbs={[
          { name: "Home", path: "/" },
          { name: "Page not found", path: "/404" },
        ]}
      />
      <section className="section">
        <div className="row">
          <div className="col-md-12 text-center thanks">
            <img
              src={require("../assets/images/logo-icon.png")}
              alt="Connct"
              className="thank-logo"
            />
            <Breadcrumbs
              items={[
                { name: "Home", path: "/" },
                { name: "Page not found", path: "/404" },
              ]}
            />
            <h1 className="title mt-4">Page not found</h1>
            <p>The page you are looking for does not exist.</p>
            <a className="btn btn-primary" href="/">
              Back to Connct
            </a>
          </div>
        </div>
      </section>
      <br />
      <br />
      <br />
      <br />
    </div>
  );
};

export default Pagenotfound;
